import { useEffect } from 'react'
import { View } from 'react-native'
import Animated, {
  Easing,
  cancelAnimation,
  useAnimatedStyle,
  useSharedValue,
} from 'react-native-reanimated'
import { colors } from '@ui/colors'
import EyeOpened from './assets/eye-opened'
import EyeClosed from './assets/eye-closed'
import {
  buildPhaseLoop,
  AnimationComponentProps as Props,
} from './phaseAnimation'

const REFERENCE_SIZE = 24

const OPENED_OPACITY = [1, 1, 0, 0]
const CLOSED_OPACITY = [0, 0, 0.25, 0.25]

const PHASE_DURATIONS = [200, 200, 200, 200]
const PHASE_DELAYS = [0, 1000, 0, 1000]
const PHASE_EASINGS = [
  Easing.linear,
  Easing.linear,
  Easing.linear,
  Easing.linear,
]

export default function EyeOpen({
  size = REFERENCE_SIZE,
  color = colors.white,
  durations = PHASE_DURATIONS,
  delays = PHASE_DELAYS,
  easings = PHASE_EASINGS,
  isActive = true,
}: Props) {
  const openedOpacity = useSharedValue(OPENED_OPACITY[0])
  const closedOpacity = useSharedValue(CLOSED_OPACITY[0])

  useEffect(() => {
    if (!isActive) {
      cancelAnimation(openedOpacity)
      cancelAnimation(closedOpacity)
      return
    }

    openedOpacity.set(
      buildPhaseLoop(OPENED_OPACITY, durations, delays, easings)
    )

    closedOpacity.set(
      buildPhaseLoop(CLOSED_OPACITY, durations, delays, easings)
    )
  }, [isActive, durations, delays, easings, openedOpacity, closedOpacity])

  const openedStyle = useAnimatedStyle(() => ({
    opacity: openedOpacity.value,
  }))

  const closedStyle = useAnimatedStyle(() => ({
    opacity: closedOpacity.value,
  }))

  return (
    <View
      style={{ width: size, height: size }}
      className="items-center justify-center"
    >
      {/* Absolute wrappers need explicit dimensions on native: without
          them the view collapses to 0x0 and the SVG at 100% renders nothing. */}
      <Animated.View
        className="absolute"
        style={[{ width: size, height: size }, openedStyle]}
      >
        <EyeOpened size="100%" color={color} />
      </Animated.View>
      <Animated.View
        className="absolute"
        style={[{ width: size, height: size }, closedStyle]}
      >
        <EyeClosed size="100%" color={color} />
      </Animated.View>
    </View>
  )
}
